import Quill from 'quill';
const Parchment = Quill.import('parchment');

let LinkClass = new Parchment.Attributor.Class('link', 'link', {
    scope: Parchment.Scope.INLINE
    // whitelist: ['el-button', 'el-button--info', 'el-button--mini', 'el-button--medium', 'el-button--large']
});

export default LinkClass;
